/**
 * Mobile Nav Drill-Down (pages-style navigation) — v2
 * -----------------------------------------------------
 * No DOM movement — every <ul class="mobile-nav__sublist"> stays exactly
 * where Liquid rendered it. It becomes a full-screen panel via
 * position:fixed (see mobile-menu-drilldown.css), anchored to #NavDrawer.
 * This preserves every existing CSS selector that depends on the original
 * nesting (mega-menu promo images, .mega-menu--mobile, etc).
 *
 * Still recommended: find and remove the old accordion JS that toggles
 * `mobile-nav--expanded` (search your theme JS for that string or for
 * "mobile-nav__toggle-open"). The CSS in this update neutralises its
 * visual side-effects, but it's still doing pointless work on every click.
 */
(function () {
  'use strict';

  var drawer = document.getElementById('NavDrawer');
  if (!drawer) return;

  var MOBILE_BREAKPOINT = 1184;

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments, ctx = this;
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  function setHeaderHeightVar() {
    var header = drawer.querySelector('.mobile-nav__logo-title');
    var h = header ? Math.round(header.getBoundingClientRect().height) : 64;
    drawer.style.setProperty('--menu-header-h', h + 'px');
  }

  function openPanel(panel) {
    if (!panel) return;
    // Close any active panel that is NOT an ancestor of this one, so we
    // never end up with two unrelated panels (e.g. "Fine Jewelry" and
    // "Shop By Price" from a stale previous session) active at the same
    // time, which is what caused the double-header stacking bug.
    var allActive = drawer.querySelectorAll('.mobile-nav__sublist.is-active');
    allActive.forEach(function (p) {
      if (p !== panel && !p.contains(panel)) {
        p.classList.remove('is-active');
      }
    });
    panel.classList.add('is-active');
    var back = panel.querySelector(':scope > .mobile-nav__panel-back .mobile-nav__back-btn');
    if (back) back.focus({ preventScroll: true });
  }

  function closePanel(panel) {
    if (!panel) return;
    panel.classList.remove('is-active');
  }

  function resetPanels() {
    var openPanels = drawer.querySelectorAll('.mobile-nav__sublist.is-active');
    openPanels.forEach(function (p) { p.classList.remove('is-active'); });
  }

  function onClick(e) {
    var trigger = e.target.closest('.mobile-nav__has-sublist');
    if (trigger) {
      var li = trigger.parentElement;
      var panel = li ? li.querySelector(':scope > .mobile-nav__sublist') : null;
      if (panel) {
        e.preventDefault();
        e.stopImmediatePropagation();
        openPanel(panel);
      }
      return;
    }

    var backBtn = e.target.closest('.mobile-nav__back-btn');
    if (backBtn) {
      var panel = backBtn.closest('.mobile-nav__sublist');
      if (panel) {
        e.preventDefault();
        e.stopImmediatePropagation();
        closePanel(panel);
      }
    }
  }

  function onResize() {
    setHeaderHeightVar();
    if (window.innerWidth > MOBILE_BREAKPOINT) resetPanels();
  }

  setHeaderHeightVar();
  drawer.addEventListener('click', onClick, true);
  window.addEventListener('resize', debounce(onResize, 150));

  // Reset the panel stack whenever the drawer closes, no matter how
  // (X button, overlay click, hamburger toggle, ESC key) — relies on the
  // `inert` attribute your drawer already toggles on open/close.
  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      if (m.attributeName === 'inert' && drawer.hasAttribute('inert')) {
        resetPanels();
      } else if (m.attributeName === 'inert' && !drawer.hasAttribute('inert')) {
        setHeaderHeightVar();
      }
    });
  });
  observer.observe(drawer, { attributes: true });
})(); 